import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
import { ViewModeType } from '@xhs/yam-beer/cmp/constants'
import { getWeekDays, dayjs } from '@xhs/yam-beer/utils/dayjs'
import { ARROW_PATH_16, SINGLE_ARROW_16 } from '@xhs/yam-beer/cmp/constants/builtinIcon'
import type { Dayjs } from 'dayjs'

type TitleProps = {
  viewMode: ViewModeType
  current: Dayjs
  setViewMode: (mode: ViewModeType) => void
}

const HeadTitle = (props: TitleProps) => {
  const {
    viewMode,
    current,
    setViewMode,
  } = props
  const year = dayjs(current).year()
  return {
    y: `${year - 4} - ${year + 5}`,
    m: (
      <NewBsBox
        bs={{ '&:hover': { color: 'brand', cursor: 'pointer' } }}
        {...{ onClick: () => setViewMode('y') } }
      >
        {`${year} 年`}
      </NewBsBox>
    ),
    d: (
      <NewBsBox bs={{ display: 'flex', whiteSpace: 'pre' }}>
        <NewBsBox
          bs={{ '&:hover': { color: 'brand', cursor: 'pointer' } }}
          {...{ onClick: () => setViewMode('y') } }
        >
          {dayjs(current).format('YYYY 年')}
        </NewBsBox>
        <div>{' '}</div>
        <NewBsBox
          bs={{ '&:hover': { color: 'brand', cursor: 'pointer' } }}
          {...{ onClick: () => setViewMode('m') } }
        >
          {dayjs(current).format('MM 月')}
        </NewBsBox>
      </NewBsBox>
    ),
  }[viewMode]
}
HeadTitle.Props = {
  viewMode: {},
  current: {},
  setViewModel: {},
}

type WeekIfDayProps = {
  viewMode: ViewModeType
}

const WeekIfDay = (props: WeekIfDayProps) => {
  if (props.viewMode !== 'd') {
    return null
  }
  const weekdays = getWeekDays()
  return (
    <NewBsBox bs={{ mb: 16, 'cmp.calendar': 'row' }}>
      {weekdays.map(i => (
        <NewBsBox
          key={i}
          bs={{
            'cmp.calendar': 'cell',
            height: 24,
          }}
        >
          {i}
        </NewBsBox>
      ))}
    </NewBsBox>
  )
}
WeekIfDay.Props = {
  viewMode: {},
}

type YearArrowIfDayProps = {
  viewMode: ViewModeType
  handleBase: (op: string, flag: boolean) => void
  isLeft: boolean
}
const YearArrowIfDay = (props: YearArrowIfDayProps) => {
  const { viewMode, handleBase, isLeft } = props
  if (viewMode !== 'd') {
    return null
  }
  let bs = {}
  if (isLeft) {
    bs = {
      'cmp.calendar': 'icon',
      mr: 8,
      transform: 'rotate(180deg)',
    }
  } else {
    bs = {
      'cmp.calendar': 'icon',
      ml: 8,
    }
  }
  return (
    <BeerIcon
      iconPath={ARROW_PATH_16}
      gridSize={16}
      size={16}
      bs={bs}
      {...{
        onClick: () => {
          if (isLeft) {
            handleBase('subtract', true)
          } else {
            handleBase('add', true)
          }
        },
      }}
    />
  )
}
YearArrowIfDay.Props = {
  viewMode: {},
  handleBase: {},
  isLeft: {},
}

type CalendarHeaderProps = {
  viewMode: ViewModeType
  current: Dayjs
  onPrev: (e: Event) => void
  onNext: (e: Event) => void
  showPrev: boolean
  showNext: boolean
  setViewMode: (mode: ViewModeType) => void
  handleBase: (op: string, flag: boolean) => void
}

const CalendarHeader = (props: CalendarHeaderProps) : any => {
  const {
    viewMode,
    onPrev,
    onNext,
    showPrev,
    showNext,
    current,
    setViewMode,
    handleBase,
  } = props
  return (
    <NewBsBox bs={{ 'cmp.calendar': 'header' }}>
      <NewBsBox bs={{ 'cmp.calendar': 'title' }}>
        <NewBsBox>
          {showPrev && (
            <YearArrowIfDay isLeft={true} viewMode={viewMode} handleBase={handleBase} />
          )}
          { showPrev && (
            <BeerIcon
              iconPath={SINGLE_ARROW_16}
              gridSize={16}
              size={16}
              bs={{
                transform: 'rotate(180deg)',
                'cmp.calendar': 'icon',
              }}
              {...{
                onClick: (e: Event) => onPrev(e),
              }}
            />
          )}
        </NewBsBox>
        <NewBsBox>
          {/* @ts-ignore */}
          <HeadTitle
            viewMode={viewMode}
            current={current}
            setViewMode={setViewMode}
          />
        </NewBsBox>
        <NewBsBox>
          { showNext && (
            <BeerIcon
              iconPath={SINGLE_ARROW_16}
              gridSize={16}
              size={16}
              bs={{
                'cmp.calendar': 'icon',
              }}
              {...{
                onClick: (e: Event) => onNext(e),
              }}
            />
          )}
          {showNext && (
            <YearArrowIfDay isLeft={false} viewMode={viewMode} handleBase={handleBase} />
          )}
        </NewBsBox>
      </NewBsBox>
      <WeekIfDay viewMode={viewMode} />
    </NewBsBox>
  )
}
CalendarHeader.Props = {
  viewMode: {},
  onPrev: {},
  onNext: {},
  showPrev: {},
  showNext: {},
  current: {},
  setViewMode: {},
  handleBase: {},
}
export default CalendarHeader
